<div class="login-banner">
	<!--<img src="../assets/img/health_profilebanner.png" alt="">-->
</div>
<div class="health-profile-hero">
	<h1>my health profile</h1>
	<p>To continue please login below.</p>
</div>
<div class="login-form">
	<form [formGroup]="loginForm">
		<div class="profileUsername input-row">
			<i class="icon i-profile"></i>
			<label>{{profileUsername}}</label>
			<input type="text" formControlName="username" name="username">
		</div>
		<div class="profilepassword input-row">
			<i class="icon i-password"></i>
			<label>Password</label>
			<input type="password" formControlName="password" name="password">
		</div>
		<!-- Momentum Wellness Custom -->
		<div class="i-next submit-btn" [hidden]="isLoading">
			<button class="btn" (click)="loginMomentumwellnessNext()"  >Next</button>
		</div>
		<div class="i-submit submit-btn" [hidden]="isLoading">
			<button class="btn" (click)="login()" [disabled]="loginForm.status == 'INVALID'">Login</button>
		</div>
		<p class="error red-error-text" *ngIf="errMsg.length > 4">{{ errMsg }}</p>
		<div class="loader" *ngIf="isLoading"></div>
		<div class="login-options" [hidden]="isLoading">
			<a routerLink="/register">Sign up?</a>
			<div>
				<a [routerLink]="['/renewpass','1Gh0928kLN']">I forgot my password</a> 
				<span>|</span> 
				<a routerLink="/renewpass">Reset my password</a>
				<span>|</span> 
				<a href="https://credentials.account.momentum.co.za/credentials?client_id=uUiON1PUSaIYELkQcvhW36ctP71L8XXN&redirect_uri=https%3A%2F%2Faccount.momentum.co.za%2Flogin%3Fstate%3DhKFo2SBITldPdURnLTVmajJ6SjdEOFRDNnBmYVk1dmdaSzFHcKFupWxvZ2luo3RpZNkgZ2ZzT0Z6aUZSb1A5Q3NyeXE0Ml9nOHVvQU5RUjFab0ujY2lk2SB1VWlPTjFQVVNhSVlFTGtRY3ZoVzM2Y3RQNzFMOFhYTg%26scope%3Dopenid%20offline_access%20profile%20email%20phone%26nonce%3DeGhXNXhoSkdreGJ4czNRcnlOMTlwN1FVdDlmYX5BbWhDRUt0dzkwODR0dGZl%26client%3DuUiON1PUSaIYELkQcvhW36ctP71L8XXN%26protocol%3Doauth2%26response_type%3Dcode" target="_blank" rel="noopener noreferrer">Unblock my account</a>
			</div>
		</div>
	</form>
</div>